import { Users } from "lucide-react";
import { Modal } from "@/components/ui/Modal";
import type { ClienteStat } from "./chartUtils";
import { RankingClientes } from "./charts/RankingClientes";

interface Props {
  open: boolean;
  onClose: () => void;
  rows: ClienteStat[];
}

export function VendedoresRankingModal({ open, onClose, rows }: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="full"
      title={
        <div className="flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-violet-50 text-violet-600">
            <Users className="h-4 w-4" />
          </div>
          <span className="text-sm font-semibold text-slate-800">
            Ranking completo de vendedores
          </span>
        </div>
      }
    >
      <RankingClientes
        data={rows}
        loading={false}
        title="Ranking de Vendedores"
        subtitle="Todos os corretores / imobiliárias (brokers)"
        showQuantity
        detailKind="client"
        expanded
      />
    </Modal>
  );
}
